import * as XLSX from "xlsx";

const formatReturnable = (value) => {
  if (value === null || value === undefined) return "N/A";
  return value ? "Yes" : "No";
};

const DownloadAllLedgersExcel = (rows, companyName, setOpenBackdrop) => {
  if (!rows || rows.length === 0) {
    alert("No data found to export!");
    return;
  }

  setOpenBackdrop?.(true);

  try {
    const sheetRows = [];
    sheetRows.push([companyName?.toUpperCase() || "COMPANY"]);
    sheetRows.push(["ALL LEDGER REPORT"]);
    sheetRows.push([]);

    const headers = [
      "S.No",
      "Transaction",
      "Name",
      "Type",
      "Reference No.",
      "Credit/Debit",
      "Month",
      "Amount",
      "Item",
      "Qty",
      "Rate",
      "Item Amount",
      "Returnable",
    ];
    sheetRows.push(headers);

    rows.forEach((row, index) => {
      const mainCols = [
        index + 1,
        row.type || "",
        row.fname || "",
        row.entity_type || "",
        row.entity_number || "",
        Boolean(row.is_credit) ? "CREDIT" : "DEBIT",
        row.month || "",
        Number(row.amount || 0),
      ];

      const items = Array.isArray(row.items) ? row.items : [];

      if (items.length === 0) {
        sheetRows.push([...mainCols, "", "", "", "", ""]);
        return;
      }

      items.forEach((item, itemIndex) => {
        sheetRows.push([
          itemIndex === 0 ? mainCols[0] : "",
          itemIndex === 0 ? mainCols[1] : "",
          itemIndex === 0 ? mainCols[2] : "",
          itemIndex === 0 ? mainCols[3] : "",
          itemIndex === 0 ? mainCols[4] : "",
          itemIndex === 0 ? mainCols[5] : "",
          itemIndex === 0 ? mainCols[6] : "",
          itemIndex === 0 ? mainCols[7] : "",
          item.itemname || "",
          item.qty ?? 0,
          item.rate ?? 0,
          item.amount ?? 0,
          formatReturnable(item.is_returnable),
        ]);
      });

      sheetRows.push([]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(sheetRows);
    worksheet["!cols"] = [
      { wch: 6 },
      { wch: 16 },
      { wch: 22 },
      { wch: 12 },
      { wch: 18 },
      { wch: 12 },
      { wch: 10 },
      { wch: 12 },
      { wch: 28 },
      { wch: 8 },
      { wch: 10 },
      { wch: 12 },
      { wch: 12 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "All Ledgers");
    XLSX.writeFile(workbook, `All_Ledgers_${Date.now()}.xlsx`);
  } catch (error) {
    console.error("Excel Generation Error:", error);
    alert("Something went wrong while generating Excel");
  } finally {
    setOpenBackdrop?.(false);
  }
};

export default DownloadAllLedgersExcel;
